import { render } from "./classify.vue?vue&type=template&id=64b92404&scoped=true"
import script from "./classify.vue?vue&type=script&lang=js"
export * from "./classify.vue?vue&type=script&lang=js"

import "./classify.vue?vue&type=style&index=0&id=64b92404&lang=scss&scoped=true"
import "./classify.vue?vue&type=style&index=1&id=64b92404&lang=css"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b92404"]])

export default __exports__